export const FETCH_SUBJECTS = 'FETCH_SUBJECTS';
export const FETCH_ERRORS_FILTER = 'FETCH_ERRORS_FILTER';
export const NEW_SUBJECT = 'NEW_SUBJECT';

export const NEW_ERROR = 'NEW_ERROR';
export const EDIT_ERROR = 'EDIT_ERROR';
export const DELETE_ERROR = 'DELETE_ERROR';
export const CHANGE_ERROR_MASTER_DEGREE = 'CHANGE_ERROR_MASTER_DEGREE';

export const FETCH_TAG_IDS = 'FETCH_TAG_IDS';
export const FETCH_TAG_COUNTS = 'FETCH_TAG_COUNTS';

export const REGISTER_USER = 'REGISTER_USER';
export const LOGIN_USER = 'LOGIN_USER';
export const LOGOUT_USER = 'LOGOUT_USER';

export const GET_INPUT_HISTORY = 'GET_INIPUT_HISTORY';
export const SET_INPUT_HISTORY = 'SET_INPUT_HISTORY';

export const FETCH_USER_VALIDITY = 'FETCH_USER_VALIDITY';

/*export const URL = 'http://222.175.171.50:8000/';*/
export const URL = 'http:///icuotiback.devlabs.cc/';
/*export const URL = 'http://127.0.0.1:8000/';*/



// WEBPACK FOOTER //
// ./src/actions/types.js